// src/hooks/productTypes/useForceDeleteAllProductTypes.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteAllProductTypes as forceDeleteAllProductTypesAPI } from "../../api/apiProductTypes";
import parseError from "../../utils/parseError";

const useForceDeleteAllProductTypes = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDeleteAll, isPending: isForceDeleteAll } = useMutation({
        mutationFn: forceDeleteAllProductTypesAPI,
        onSuccess: (res) => {
            const message = res?.message || "Product types permanently deleted";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["productTypes"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to delete product types permanently");
        },
    });

    return { forceDeleteAllProductTypes: forceDeleteAll, isForceDeleteAll };
};

export default useForceDeleteAllProductTypes;